import { PlayerMetricHeuristic } from '../../jscaip/AI/PlayerMetricHeuristic';
import { PlayerNumberTable } from '../../jscaip/PlayerNumberTable';
export class ApagosFullBoardHeuristic extends PlayerMetricHeuristic {
    getMetrics(node, _config) {
        const result = PlayerNumberTable.of([0, 0, 0, 0], [0, 0, 0, 0]);
        const board = node.gameState.board;
        const size = board.length;
        for (let i = 0; i < size; i++) {
            const levelDominant = board[size - 1 - i].getDominatingPlayer();
            if (levelDominant.isPlayer()) {
                result.add(levelDominant, i, 1);
            }
        }
        return result;
    }
}
